import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {MessageService} from '../chat/message.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {AdminService} from '../../../services/admin.service';
import * as moment from 'moment';
import {TestingProcessService} from './testing-action/testing-process.service';
import {ApiConnectService} from '../../../services/api-connect.service';
import {NotificationsService} from '../../../services/notifications.service';
import {LanguageSwitcher} from '../../../header/language-switcher/language-switcher.model';
import {SuggestionListsService} from '../../common/suggestion-lists/services/suggestion-lists.service';
import {ViewDocxComponent} from '../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../services/view-docx.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import 'rxjs/add/observable/forkJoin';
import {FullUser} from '../../../models/full-user.model';

const ACTIVE_STANDARD = 'ACTIVE';
const EXTERNAL_FAMILIARIZATION_ROUTE = 'ex-notification-familiarize-action/';
const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';
const NAME_SEPARATOR = ' ';
const USER_RESPONSE_INDEX = 0;
const STANDARD_RESPONSE_INDEX = 1;
const PROGRESS_RESPONSE_INDEX = 2;
const HTTP_OK = 200;
const ENABLED_QUERY = 'true';
const STANDARD_TYPE_KEY = 'standartType';
interface FamiliarizationProgress {
  user: {id: string};
  acknowledgementDate?: string;
  modificationRequestDate?: string;
  confirmationDate?: string;
  testingDate?: string;
}
interface StandardChangeLog { username: string; date: string; note: string; }

@Component({
  selector: 'app-user-familiarize-standard',
  templateUrl: './user-familiarize-standard.component.html',
  styleUrls: ['./user-familiarize-standard.component.css'],
  providers: [LanguageSwitcher]
})
export class UserFamiliarizeStandardComponent implements OnInit, OnDestroy {
  @ViewChild('spanList') el:ElementRef;
  testingLoad = false;
  isClicked = false;
  isLoaded = false;
  public standardId: string;
  standard: any;
  stringDate: string;
  nextTwoBtn = false; // familiarizationDate
  nextModificationBtn = false;
  nextApprovedBtn = false;
  ftwoError = false;
  testingIsDone = false;
  canFam = false;
  cUserName = '';
  cUserID = null;
  cUser: any;
  showInputMessage: boolean;
  public userLanguage: string;
  isLoadedFamiliarize = true;
  changeLogs;
  showLogs = false;
  type;
  loadFailed = false;
  private standardLoad: Subscription;
  private routeSubscription: Subscription;
  private querySubscription: Subscription;
  private changeLogSubscription: Subscription;

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              public viewDocxService: ViewDocxService,
              private modalService: NgbModal,
              private notificationsService: NotificationsService,
              private adminService: AdminService,
              private userService: UserService,
              private apiConnectService: ApiConnectService,
              private stepsControllerService: StepsControllerService,
              public messageService: MessageService,
              public testingProcessService: TestingProcessService,
              public languageSwitcher: LanguageSwitcher,
              private suggestionListsService: SuggestionListsService) {
  }


  ngOnDestroy() {
    if (this.standardLoad) { this.standardLoad.unsubscribe(); }
    if (this.routeSubscription) { this.routeSubscription.unsubscribe(); }
    if (this.querySubscription) { this.querySubscription.unsubscribe(); }
    if (this.changeLogSubscription) { this.changeLogSubscription.unsubscribe(); }
    this.stepsControllerService.setLogsID(null);
  }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.standardId = params.id;
      this.isLoaded = false;
      this.getFamStandard();
      this.getChangeLog();
      this.checkType();
    });
    this.querySubscription = this.route.queryParams.subscribe(() => this.checkType());
  }

  checkType(storage: Storage = localStorage): void {
    this.type = this.route.snapshot.queryParams.onboarding === ENABLED_QUERY ? null : storage.getItem(STANDARD_TYPE_KEY);
  }

  getChangeLog(){
    if (this.changeLogSubscription) { this.changeLogSubscription.unsubscribe(); }
    this.changeLogs = null;
    this.changeLogSubscription = this.adminService.getChangeLogs(this.standardId).subscribe(
      (res: HttpResponse<StandardChangeLog[]>) => {
        if (res.status === HTTP_OK) {
          this.changeLogs = res.body.reverse();
        }
      },
      () => { this.changeLogs = null; }
    );
  }

  confirm() {
    this.isClicked = true;
    let obj = JSON.parse(localStorage.getItem('notificationCategory'));
    this.adminService.notifyIsViewNot(obj).subscribe(
      (response: any) => {
        localStorage.removeItem('notificationCategory');
        this.router.navigate(['/dashboard']);
      },
      () => {
      }
    );
  }

  getFamStandard() {
    if (this.standardLoad) { this.standardLoad.unsubscribe(); }
    this.resetFamiliarization();
    this.stringDate = moment().format(DISPLAY_DATE_FORMAT);
    this.standardId = this.route.snapshot.params.id;
    this.stepsControllerService.setLogsID(this.standardId);
    this.standardLoad = Observable.forkJoin([
      this.userService.getSelf(),
      this.adminService.getStandard(this.standardId),
      this.stepsControllerService.getFamiliarizedInfo(this.standardId)
    ]).subscribe(responses => this.acceptFamiliarization(responses), () => {
      this.loadFailed = true;
      this.isLoaded = true;
    });
  }

  private resetFamiliarization(): void {
    this.isLoaded = false;
    this.loadFailed = false;
    this.standard = null;
    this.testingIsDone = false;
    this.nextTwoBtn = false;
    this.nextModificationBtn = false;
    this.nextApprovedBtn = false;
    this.testingProcessService.successMsg = false;
    this.testingProcessService.showTesting = false;
  }

  private acceptFamiliarization(responses: HttpResponse<Object>[]): void {
    this.cUser = responses[USER_RESPONSE_INDEX].body as FullUser;
    this.cUserID = this.cUser.id;
    this.cUserName = this.cUser.firstName + NAME_SEPARATOR + this.cUser.lastName;
    this.userLanguage = this.cUser.language;
    this.standard = responses[STANDARD_RESPONSE_INDEX].body;
    if (this.router.url.includes(EXTERNAL_FAMILIARIZATION_ROUTE)) {
      this.stepsControllerService.setCurrentStandard(this.standard);
    }
    this.testingProcessService.setStandard(this.standard);
    this.messageService.setTempStandard(this.standard);
    const users = (responses[PROGRESS_RESPONSE_INDEX].body || []) as FamiliarizationProgress[];
    this.applyFamiliarization(users.find(item => !!item.user && item.user.id === this.cUserID));
    this.isLoaded = true;
  }

  private applyFamiliarization(progress: FamiliarizationProgress): void {
    this.nextTwoBtn = !!progress && !!progress.acknowledgementDate;
    this.nextApprovedBtn = !!progress && !!progress.confirmationDate;
    this.nextModificationBtn = !!progress && !!progress.modificationRequestDate && !this.nextApprovedBtn;
    this.testingIsDone = !!progress && !!progress.testingDate;
    this.testingProcessService.showTesting = this.standard.status === ACTIVE_STANDARD && !this.testingIsDone;
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }


  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }


  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
      }
    );

  }

  familiarizeWithStandard() {
    this.ftwoError = false;
    this.isLoadedFamiliarize = false;
    this.userService.doFamiliarizeWithStandard(this.standard.id).subscribe(
      (response: any) => {
        this.isLoadedFamiliarize = true;

        this.nextTwoBtn = true;
        this.notificationsService.getNearNotificationFromAPI();
        this.goToExNotifList();
      },
      () => {
        this.isLoadedFamiliarize = true;
      }
    );
  }

  goToExNotifList() {
    if (this.router.url.includes('ex-notification-familiarize-action/')) {
      this.router.navigate(['/ex-notifications']);
    }
  }

  approved() {
    this.userService.doApproved(this.standard.id).subscribe(
      (response: any) => {
        this.nextModificationBtn = false;
        this.nextApprovedBtn = true;
      },
      () => {
      }
    );
  }

  requiresModification() {
    this.userService.doRequiresModification(this.standard.id).subscribe(
      (response: any) => {
        this.nextModificationBtn = true;
        this.nextApprovedBtn = false;
      },
      () => {
      }
    );
  }

  addNewSL() {
    this.suggestionListsService.setListType('standard');
    this.suggestionListsService.setStandard(this.standard);
    this.router.navigate(['/dashboard/create-suggestion-list']);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/user-familiarize-standard/user-familiarize-standard.component.ts